//线上支付
export const online_payment = 0;

//交易类型 下支付
export const offline_payment = 1;

//交易类型 钱包支付
export const wallet_payment = 2;

//付款模式 微信支付交易
export const trade_wechat = 0;

//付款模式 支付宝
export const trade_ali = 1;

//付款模式 银行
export const trade_bank = 2;

//付款模式 电汇
export const trade_remittance = 3;

//付款模式 钱包
export const trade_wallet = 20;

let payTypesMap = {
    onlinePay: online_payment, //在线支付
    offlinePay: offline_payment, //线下支付
};

export { payTypesMap };
